import { AppLayout } from 'layouts';
import { lazy, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Loadable, Page } from 'components';
import { setRouting } from 'toolkits/redux/routing';
import { Navigate, useRoutes } from 'react-router-dom';

const NotFound = Loadable(lazy(() => import('screens/Authentication/Page404')));
const Dashboard = Loadable(lazy(() => import('screens/UnitAdminRole/Dashboard')));

const UserModel = Loadable(lazy(() => import('models/UserModel')));
const ShopModel = Loadable(lazy(() => import('models/ShopModel')));
const CouponModel = Loadable(lazy(() => import('models/CouponModel')));
const ProductShopModel = Loadable(lazy(() => import('models/ProductShopModel')));
const UserCategoryModel = Loadable(lazy(() => import('models/UserCategoryModel')));
const OrderModel = Loadable(lazy(() => import('models/OrderModel')));

const navConfig = [
  {
    path: '/',
    element: <Navigate to="/app" replace />,
  },
  {
    url: '/',
    path: '/',
    title: 'app',
    inSidebar: true,
    element: <AppLayout />,
    children: [
      {
        url: '/app',
        path: '/app',
        title: 'app',
        inSidebar: true,
        element: <Dashboard />,
      },
      {
        url: '/user',
        path: '/user',
        title: 'users',
        inSidebar: true,
        element: (
          <Page title="Users">
            <UserModel />
          </Page>
        ),
      },
      {
        url: '/user-category',
        path: '/user-category',
        title: 'usersCategory',
        inSidebar: true,
        element: (
          <Page title="User Category">
            <UserCategoryModel />
          </Page>
        ),
      },

      {
        url: '/shop',
        path: '/shop',
        title: 'shops',
        inSidebar: true,
        element: (
          <Page title="Shops">
            <ShopModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },

      {
        url: '/order',
        path: '/order',
        title: 'orders',
        inSidebar: true,
        element: (
          <Page title="Orders">
            <OrderModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },

      {
        url: '/coupon',
        path: '/coupon',
        title: 'coupons',
        inSidebar: true,
        element: (
          <Page title="Coupons">
            <CouponModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },

      {
        url: '/product-shop',
        path: '/product-shop',
        title: 'productShop',
        inSidebar: true,
        element: (
          <Page title="ProductShop">
            <ProductShopModel initFilter={{}} />
          </Page>
        ),
      },
    ],
  },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: 'intro',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'sign-in',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'sign-up',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'reset-password',
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

function cleanRoutes({ url, title, inSidebar, children }) {
  if (inSidebar) {
    if (children && children.length > 0) {
      children = children.map((c) => cleanRoutes(c));
      return { url, title, inSidebar, children };
    }
    return { url, title, inSidebar, children: [] };
  }
  return {};
}

export default function Router() {
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(navConfig.map((x) => cleanRoutes(x)).filter((x) => x));
    dispatch(setRouting(navConfig.map((x) => cleanRoutes(x)).filter((x) => x)));
  }, []);
  return useRoutes(navConfig);
}
